<template>
  <div id="ppc">
    <div
      class="container form-container success-message-container"
      v-if="form_successful"
    >
      <div class="row">
        <div class="col-sm-12 form-success-ctn">
          <!--<p class="form-message form-success-message">Thank you for your form submission. Your Tint World store will reach out to you with additional information.</p>-->
          <FormSuccess></FormSuccess>
        </div>
      </div>
    </div>
    <div class="container form-wrapper" v-if="!form_successful">
      <div class="row tab-container">
        <div class="col-xs-6 no-padding">
          <button
            class="btn btn-primary w-100 btn-form-tab"
            v-bind:class="{ active: quoteActive }"
            :active="formType == 'quote'"
            @click="switchFormType('quote')"
          >
            Get A<br />Free Quote
          </button>
        </div>
        <div class="col-xs-6 no-padding tab-right">
          <button
            class="btn btn-primary w-100 btn-form-tab"
            v-bind:class="{ active: appointmentActive }"
            :active="formType == 'appointment'"
            @click="switchFormType('appointment')"
          >
            Request<br />Appointment
          </button>
        </div>
      </div>
      <div class="form-container form_tabs container">
        <div class="row message-ctn">
          <div class="col-sm-12" v-if="formType == 'appointment'">
            <p class="title">Complete form to request an appointment.</p>
          </div>
          <div class="col-sm-12" v-if="formType == 'quote'">
            <p class="title">Complete form to receive a free quote.</p>
          </div>
        </div>
        <div class="row" v-if="critical_error">
          <div class="col-sm-12">
            <p class="error-message">
              There was an issue with your form submission. Please check your
              information and try again.
            </p>
          </div>
        </div>
        <div class="row" v-if="$v.$invalid && $v.$anyError && !has_error">
          <div class="col-sm-12">
            <p class="error-message mt-1 mb-1">
              Check the highlighted fields below for possible errors.
            </p>
          </div>
        </div>
        <div class="row" v-if="has_error">
          <div class="col-sm-12">
            <p
              class="error-message mt-1 mb-1"
              v-for="(error, index) in validation_errors"
              :key="index"
            >
              <span v-if="index !== 'phone' && index !== 'email'"
                >{{ index }}: {{ error[0] }}</span
              >
              <span v-else>
                Check the highlighted fields below for possible errors.</span
              >
            </p>
          </div>
        </div>
        <div class="row" v-if="response.responseCode == 2">
          <p class="error-message">
            Your requested appointment date is not available. Please choose a
            different date.
          </p>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <form class="form form_tabs" @submit.prevent="submit">
              <div class="row">
                <div class="col-sm-12">
                  <input type="hidden" v-model="storeID" />
                  <input type="hidden" v-model="formType" />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.first_name.$error }"
                  >
                    <label class="form__label w-100">First Name*:</label>
                    <input
                      class="form__input w-100 form-control"
                      v-model="first_name"
                      required
                    />
                  </div>
                  <div
                    class="error"
                    v-if="!$v.first_name.required && $v.first_name.$error"
                  >
                    Field is required
                  </div>
                </div>
                <div class="col-sm-6">
                  <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.last_name.$error }"
                  >
                    <label class="form__label w-100">Last Name*:</label>
                    <input
                      class="form__input w-100 form-control"
                      v-model="last_name"
                      required
                    />
                  </div>
                  <div
                    class="error"
                    v-if="!$v.last_name.required && $v.last_name.$error"
                  >
                    Field is required
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div
                    class="form-group"
                    :class="[
                      { 'form-group--error': $v.phone.$error },
                      { invalid: has_error && highlightErrors('phone') },
                    ]"
                  >
                    <label class="form__label w-100 text-align-left"
                      >Phone Number*:</label
                    >
                    <input
                      class="form__input w-100 form-control"
                      type="tel"
                      v-model="phone"
                      required
                    />
                  </div>
                  <div
                    class="error"
                    v-if="!$v.phone.required && $v.phone.$error"
                  >
                    Field is required
                  </div>
                  <div
                    class="error"
                    v-if="has_error && highlightErrors('phone')"
                  >
                    {{ validation_errors.phone[0] }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.email.$error }"
                  >
                    <label class="form__label text-align-left w-100"
                      >Email Address*:</label
                    >
                    <input
                      class="form__input w-100 form-control"
                      v-model="email"
                      required
                    />
                  </div>
                  <div
                    class="error"
                    v-if="!$v.email.required && $v.email.$error"
                  >
                    Field is required
                  </div>
                  <div class="error" v-if="!$v.email.email">
                    Please enter a valid email format.
                  </div>
                  <div
                    class="error"
                    v-if="has_error && highlightErrors('email')"
                  >
                    {{ validation_errors.email[0] }}
                  </div>
                </div>
              </div>
              <!-- Start Conditional Logic For Other Fields -->
              <div class="vehicle-fields" v-if="showVehicleFields">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="form__label text-align-left w-100"
                        >Vehicle Year*:</label
                      >
                      <b-form-select
                        @change="selYear"
                        v-model="year"
                        :options="options_year"
                        class="form__input w-100 form-control"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="form__label text-align-left w-100"
                        >Vehicle Make*:</label
                      >
                      <b-form-select
                        class="form__input w-100 form-control"
                        @change="selMake"
                        v-model="make"
                        :options="options_make"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="form__label text-align-left w-100"
                        >Vehicle Model*:</label
                      >
                      <b-form-select
                        v-model="model"
                        :options="options_model"
                        class="form__input w-100 form-control"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="form__label text-align-left w-100"
                        >Vehicle Doors*:</label
                      >
                      <b-form-select
                        class="form__input w-100 form-control"
                        v-model="doors"
                        :options="options_door"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End Vehicle Fields -->
              <div class="row" v-if="lpType == 'index'">
                <div class="col-sm-12">
                  <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.user_services.$error }"
                  >
                    <label class="form__label text-align-left w-100"
                      >Service of Interest*:</label
                    >
                    <b-form-select
                      class="form__input w-100 form-control"
                      v-model="user_services"
                      :options="page_services"
                      placeholder="Please Select A Service*"
                      required
                    ></b-form-select>
                  </div>
                  <div
                    class="error"
                    v-if="!$v.user_services.required && $v.user_services.$error"
                  >
                    Field is required
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-if="lpType !== 'index' && lpType !== 'automotive-services'"
              >
                <div
                  class="col-sm-6"
                  v-if="lpType == 'marine-services' && page_services.length > 0"
                >
                  <div class="form-group">
                    <label class="form__label text-align-left w-100"
                      >Vessel Type*:</label
                    >
                    <b-form-select
                      class="form__input w-100 form-control"
                      v-model="marine_type"
                      :options="options_vessel"
                      placeholder="Please Select A Service*"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div
                  class="col-sm-6"
                  v-if="
                    lpType == 'residential-services' && page_services.length > 0
                  "
                >
                  <div class="form-group">
                    <label class="form__label text-align-left w-100"
                      >Home Type*:</label
                    >
                    <b-form-select
                      class="form__input w-100 form-control"
                      v-model="residential_type"
                      :options="options_residential"
                      placeholder="Please Select A Service*"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div
                  class="col-sm-6"
                  v-if="
                    lpType == 'commercial-services' && page_services.length > 0
                  "
                >
                  <div class="form-group">
                    <label class="form__label text-align-left w-100"
                      >Building Type*:</label
                    >
                    <b-form-select
                      class="form__input w-100 form-control"
                      v-model="commercial_type"
                      :options="options_building"
                      placeholder="Please Select A Service*"
                      required
                    ></b-form-select>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div
                    class="form-group"
                    :class="{ 'form-group--error': $v.user_services.$error }"
                  >
                    <label class="form__label text-align-left w-100"
                      >Service of Interest*:</label
                    >
                    <b-form-select
                      class="form__input w-100 form-control"
                      v-model="user_services"
                      :options="page_services"
                      placeholder="Please Select A Service*"
                      required
                    ></b-form-select>
                  </div>
                  <div
                    class="error"
                    v-if="!$v.user_services.required && $v.user_services.$error"
                  >
                    Field is required
                  </div>
                </div>
              </div>
              <div class="row" v-if="formType == 'appointment'">
                <div class="col-sm-6">
                  <div
                    class="form-group"
                    :class="{
                      invalid:
                        ($store.state.user.requested_appointment_date == null &&
                          submitAttempted) ||
                        highlightErrors('requested_appointment_date'),
                    }"
                  >
                    <label class="form__label text-align-left w-100"
                      >Appointment Date*:</label
                    >
                    <datepicker
                      format="MM/dd/yyyy"
                      :disabled-dates="dynamicDisabledDates"
                      v-model="user_selected_date"
                      ref="appointment_date_picker"
                      maximum-view="day"
                      @changedMonth="changedMonth"
                      bootstrap-styling
                      required
                    ></datepicker>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="form__label text-align-left w-100"
                      >Appointment Time*:</label
                    >
                    <b-form-select
                      class="form__input w-100 form-control"
                      v-model="user_selected_time"
                      :options="appointmentOptions.availableTimes"
                      placeholder="Please Select Time*"
                      required
                    ></b-form-select>
                  </div>
                </div>
              </div>
              <!-- End Appointment Fields -->
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="form__label text-align-left w-100"
                      >Questions/Comments:</label
                    >
                    <textarea
                      class="form__input w-100"
                      v-model="notes"
                      placeholder="Tell Us About Your Service Needs"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="signupcontainer">
                    <div class="signupleft">
                      <p>
                        <label style="text-align: left !important"
                          >By submitting this form and leaving "yes" checked,
                          you consent to receive informational and marketing SMS
                          messages from Tint World at the number provided,
                          including messages sent by autodialer. Consent is not
                          a condition of purchase. Msg & data rates may apply.
                          Msg frequency varies. Unsubscribe at any time by
                          replying STOP or clicking the unsubscribe link (where
                          available).</label
                        >
                      </p>
                    </div>
                    <div class="signupright">
                      <input
                        type="radio"
                        checked=""
                        name="EmailClubSignup"
                        value="Yes"
                      />Yes
                      <input type="radio" value="No" name="EmailClubSignup" />No
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <b-overlay
                    :show="apiProcessing"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block"
                    @hidden="onHidden"
                  >
                    <button
                      ref="submitButton"
                      type="submit"
                      class="submit w-100"
                      :disabled="apiProcessing"
                    >
                      <span
                        class="ppc-form-submit"
                        v-if="formType == 'appointment'"
                        >Request Appointment</span
                      >
                      <span class="ppc-form-submit" v-if="formType == 'quote'"
                        >Get Free Quote</span
                      >
                      <!-- @TODO - Can probably do a basic spinner animation above using the span view logic -->
                    </button>
                  </b-overlay>
                  <!--@TODO - Make the below work with Skeleton? Or some sort of loading animation? Def disable the submit button while it's processing -->
                  <p class="typo__p" v-if="submitStatus === 'ERROR'">
                    Please fill the form correctly.
                  </p>
                  <p class="typo__p" v-if="submitStatus === 'PENDING'">
                    Sending...
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="privacy-policy-link">
              <a data-toggle="modal" href="#Privacy" class="">Privacy Policy</a>
            </p>
          </div>
        </div>
        <div class="form-arrow-image" style="position: relative">
          <img
            class="arrow"
            src="https://www.tintworld.com/lnd/v2/assets/img/rlc-green-arrow.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import datepicker from "vuejs-datepicker";
const touchMap = new WeakMap();
//@TODO - Refactor around loading direct from JSON
//import json from './service-options.json'
import FormSuccess from "@/components/partials/PpcFormSuccess";
const default_opt_residential = {
  value: null,
  text: "Select Residential Type*",
  disabled: true,
};
const default_opt_building = {
  value: null,
  text: "Select Building Type*",
  disabled: true,
};
const default_opt_vessel = {
  value: null,
  text: "Select Vessel Type*",
  disabled: true,
};
const default_opt_year = { value: null, text: "Select Year*", disabled: true };
const default_opt_make = { value: null, text: "Select Make*", disabled: true };
const default_opt_model = {
  value: null,
  text: "Select Model*",
  disabled: true,
};
export default {
  name: "PPC",
  components: {
    datepicker,
    FormSuccess,
  },
  data() {
    return {
      //@NOTE - Defaulting to Quote Since That Form is Visible By Default
      lpType: "index",
      submitAttempted: false,
      submitStatus: null,
      submitErrors: [],
      quoteCampaign: null,
      validationError: false,
      apptCampaign: null,
      formStartedSent: false,
      options_door: [
        { value: null, text: "# of Doors", disabled: true },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
      ],
      serviceDetails: {
        serviceOptions: [],
        services: "automotive-services",
        subService: "",
      },
      appointmentOptions: {
        reqApptDate: "",
        reqApptTime: "",
        appointmentDate: "",
        appointmentTime: "",
        appointmentText: "",
        availableTimes: [
          { text: "Please Select Time*", value: null, disabled: true },
          "8:00AM",
          "8:30AM",
          "9:00AM",
          "9:30AM",
          "10:00AM",
          "10:30AM",
          "11:00AM",
          "11:30AM",
          "12:00PM",
          "12:30PM",
          "1:00PM",
          "1:30PM",
          "2:00PM",
          "2:30PM",
          "3:00PM",
          "3:30PM",
          "4:00PM",
          "4:30PM",
          "5:00PM",
          "5:30PM",
        ],
      },
      vehicleOptions: {
        years: [],
        makes: [],
        lazyModels: [],
        models: [],
        doors: ["2 Door", "3 Door", "4 Door", "4 Door Hatch"],
        vehicleYear: "",
        vehicleMake: "",
        vehicleModel: "",
        vehicleDoors: "",
      },
      disabledDate: {
        //@TODO - By Default we should do a ASYNC request on load, have the system search for the month of July, build the response and deliver the to / from format
        //@TODO - We'll setup a system that returns the initial results, and then on userMonthChange, we provide a visual lookup reference and query the next month and append the results
        //to: this.disabledDates(),
        //from: '',
        //days: [0]
        to: null,
        from: null,
        dates: [],
      },
    };
  },
  validations: {
    user_services: {
      required,
    },
    first_name: {
      required,
    },
    last_name: {
      required,
    },
    email: {
      required,
      email,
    },
    phone: {
      required,
    },
    user_store: {
      required,
    },
  },
  watch: {
    submitErrors: function (val) {
      //@TODO - this.primaryContactDetails .each and check for keys -> output response errors
      if ("emailAddress" in val) {
        this.$v.$reset();
        this.$v.$touch();
      }
    },
  },
  computed: {
    //@TODO - Would need to "touch" / force a recalc when changing between appt/quote/etc.
    //validations(){}, Can use a function to make the validated fields "dynamic" / could build the consistent state as an object, always return at the bottom, and then swap in/out the keys that need to change
    first_name: {
      get() {
        return this.$store.state.user.first_name;
      },
      set(value) {
        if (value == "") {
          this.$store.commit("setUserFieldNull", "first_name");
        } else {
          this.$store.commit("setUser", { first_name: value });
        }
        this.$v.first_name.$touch();
      },
    },
    last_name: {
      get() {
        return this.$store.state.user.last_name;
      },
      set(value) {
        if (value == "") {
          this.$store.commit("setUserFieldNull", "last_name");
        } else {
          this.$store.commit("setUser", { last_name: value });
        }
        this.$v.last_name.$touch();
      },
    },
    email: {
      get() {
        return this.$store.state.user.email;
      },
      set(value) {
        if (value == "") {
          this.$store.commit("setUserFieldNull", "email");
        } else {
          this.$store.commit("setUser", { email: value });
        }
        this.$v.email.$touch();
      },
    },
    phone: {
      get() {
        return this.$store.state.user.phone;
      },
      set(value) {
        if (value == "") {
          this.$store.commit("setUserFieldNull", "phone");
        } else {
          this.$store.commit("setUser", { phone: value });
        }
        this.$v.phone.$touch();
      },
    },
    user_services: {
      get() {
        return this.$store.state.user.ppc_service;
      },
      set(value) {
        this.$store.commit("setUserPPCServices", value);
        this.$v.user_services.$touch();
      },
    },
    gclid: {
      get() {
        return this.$store.state.user.gclid;
      },
      set(value) {
        if(value == null){
          this.$store.commit("setGclidNull");
        } else {
          this.$store.commit("setGclid", value);
        }
      },
    },
    marine_type: {
      get() {
        return this.$store.state.user.marine_type;
      },
      set(value) {
        if (value == null) {
          this.$store.commit("setUserFieldNull", "marine_type");
        } else {
          this.$store.commit("setUser", { marine_type: value });
        }
        //this.$v.first_name.$touch()
      },
    },
    residential_type: {
      get() {
        return this.$store.state.user.residential_type;
      },
      set(value) {
        if (value == null) {
          this.$store.commit("setUserFieldNull", "residential_type");
        } else {
          this.$store.commit("setUser", { residential_type: value });
        }
        //this.$v.first_name.$touch()
      },
    },
    commercial_type: {
      get() {
        return this.$store.state.user.commercial_type;
      },
      set(value) {
        if (value == null) {
          this.$store.commit("setUserFieldNull", "commercial_type");
        } else {
          this.$store.commit("setUser", { commercial_type: value });
        }
        //this.$v.first_name.$touch()
      },
    },
    notes: {
      get() {
        return this.$store.state.user.notes;
      },
      set(value) {
        if (value == "") {
          this.$store.commit("setUserFieldNull", "notes");
        } else {
          this.$store.commit("setUser", { notes: value });
        }
      },
    },
    year: {
      get() {
        return this.$store.state.user.vehicle.year;
      },
      set(value) {
        this.$store.commit("setUser", { year: value });
      },
    },
    make: {
      get() {
        return this.$store.state.user.vehicle.make;
      },
      set(value) {
        this.$store.commit("setUser", { make: value });
      },
    },
    model: {
      get() {
        return this.$store.state.user.vehicle.model;
      },
      set(value) {
        this.$store.commit("setUser", { model: value });
      },
    },
    doors: {
      get() {
        return this.$store.state.user.vehicle.doors;
      },
      set(value) {
        this.$store.commit("setUser", { doors: value });
      },
    },
    user_selected_date: {
      get() {
        return this.$store.state.user.requested_appointment_date;
      },
      set(dateObj) {
        this.$store.commit("userSelectedAppointmentDate", dateObj);
      },
    },
    user_selected_time: {
      get() {
        return this.$store.state.user.requested_appointment_time;
      },
      set(timeObj) {
        this.$store.commit("userSelectedAppointmentTime", timeObj);
      },
    },
    formType: {
      get() {
        return this.$store.state.user.ppc_form_type;
      },
      set(value) {
        this.$store.commit("togglePpcFormState", value);
      },
    },
    critical_error() {
      return this.$store.state.critical_form_error;
    },
    has_error() {
      return this.$store.getters.ppcFormErrors;
    },
    error_keys() {
      if (this.has_error) {
        return Object.keys(this.validation_errors);
      }
      return false;
    },
    validation_errors() {
      if (this.has_error) {
        if (this.$store.state.components.quote.errors !== null) {
          return this.$store.state.components.quote.errors;
        }
        if (this.$store.state.components.appointment.errors !== null) {
          return this.$store.state.components.appointment.errors;
        }
      }
      return false;
    },
    form_errors() {
      if (this.$store.state.form_response.responseErrors == null) {
        return false;
      }
      if (this.$store.state.form_response.responseErrors.length == 0) {
        return false;
      } else {
        return this.$store.state.form_response.responseErrors;
      }
    },
    disabled_dates() {
      return this.$store.state.ppc_disabled_dates;
    },
    disabled_to() {
      return this.$store.state.ppc_disabled_to;
    },
    disabled_from() {
      return this.$store.state.ppc_disabled_from;
    },
    storeID() {
      return this.$store.state.user.ppc_store;
    },
    campaign() {
      return this.$store.state.user.campaign;
    },
    page_services() {
      return this.$store.getters.ppc_services;
    },
    user_store() {
      return this.$store.state.user.ppc_store;
    },
    formServices() {
      return this.$store.state.form_service_options;
    },
    response() {
      return this.$store.state.form_response;
    },
    apiProcessing() {
      return this.$store.state.form_processing;
    },
    form_complete() {
      return this.$store.getters.ppcFormComplete;
    },
    form_successful() {
      if (
        this.$store.state.form_response.responseCode !== null &&
        this.$store.state.form_response.responseCode == 1
      ) {
        return true;
      }
      return false;
    },
    displayErrors() {
      //@TODO - Let's use this one
      if (this.submitErrors.length == 0) {
        //Do Nothing
        return false;
      } else {
        return true;
      }
    },
    dynamicDisabledDates() {
      return this.$store.getters.ppcAvailability;
    },
    showVehicleFields() {
      const vm = this;
      if (vm.lpType == "index" || vm.lpType == "automotive-services") {
        return true;
      }
      return false;
    },
    quoteActive() {
      const vm = this;
      if (vm.formType == "quote") {
        return true;
      } else {
        return false;
      }
    },
    appointmentActive() {
      const vm = this;
      if (vm.formType == "appointment") {
        return true;
      } else {
        return false;
      }
    },
    options_residential() {
      var data = [];
      data.push(default_opt_residential);
      if (
        this.$store.state.appt_options_residential &&
        this.$store.state.appt_options_residential.length > 0
      ) {
        for (var k of this.$store.state.appt_options_residential) {
          data.push({ value: k, text: k, disabled: false });
        }
      }
      return data;
    },
    options_building() {
      var data = [];
      data.push(default_opt_building);
      if (
        this.$store.state.appt_options_commercial &&
        this.$store.state.appt_options_commercial.length > 0
      ) {
        for (var k of this.$store.state.appt_options_commercial) {
          data.push({ value: k, text: k });
        }
      }
      return data;
    },
    options_vessel() {
      var data = [];
      data.push(default_opt_vessel);
      if (
        this.$store.state.appt_options_marine &&
        this.$store.state.appt_options_marine.length > 0
      ) {
        for (var k of this.$store.state.appt_options_marine) {
          data.push({ value: k, text: k });
        }
      }
      return data;
    },
    options_year() {
      var years = [];
      years.push(default_opt_year);
      if (this.$store.state.carYears && this.$store.state.carYears.length > 0) {
        for (var k of this.$store.state.carYears) {
          years.push({ value: k, text: k });
        }
      }
      return years;
    },
    options_make() {
      var makes = [];
      makes.push(default_opt_make);
      if (this.$store.state.carMakes && this.$store.state.carMakes.length > 0) {
        for (var k of this.$store.state.carMakes) {
          makes.push({ value: k.make, text: k.make });
        }
      }
      return makes;
    },
    options_model() {
      //@TODO - Check this area out, may need to make a secondary data variable for tracking the non-selected versions
      //@TODO - We should refactor this into a computed property on Vuex so we can apply to all vehicle areas
      var models = [];
      models.push(default_opt_model);
      if (!this.make || this.make == null) {
        return models;
      }
      if (this.$store.state.carMakes && this.$store.state.carMakes.length > 0) {
        var findModels = this.$store.state.carMakes.find(
          (m) => m.make === this.make
        ).models;
        for (var k of findModels) {
          models.push({ value: k, text: k });
        }
      }
      return models;
    },
    user_submission() {
      return this.$store.getters.ppcFormData;
    },
  },
  created() {
    const vm = this;
    vm.$store.commit("resetServices");
    vm.$store.commit("resetUserForm", "quote");
    vm.$store.commit("setUserCurrentPage");
    //@TODO - We can probably check if this was previously assigned rather than adding an additional AJAX Request
    vm.$store.dispatch("loadCarYears");
    this.$store.commit("userSelectedAppointmentDate", null);
    this.$store.commit("userSelectedAppointmentTime", null);
    if (window.$lpType) {
      vm.lpType = window.$lpType;
    } else {
      vm.$lpType = "index";
    }
    //@TODO - This is looking at if $services is assigned and currently we only use this
    if (window.$services && vm.lpType == "automotive-services") {
      vm.$store.commit("setUserPPCServices", window.$services);
    }
    vm.setCategory();
    vm.$store.dispatch("loadFormServices");
    if (window.$formType) {
      vm.formType = window.$formType;
    }
    if (window.$storeID) {
      vm.$store.commit("setPpcStore", window.$storeID);
    }
    vm.apptCampaign = window.$apptCampaign;
    vm.quoteCampaign = window.$quoteCampaign;
    vm.$store.commit("setPpcCampaign", vm.quoteCampaign);
  },
  mounted() {

    // @TODO - Let's set the GCLID to NULL by default when mounting, and then attach the GCLID conditionally on page load
    const vm = this;
    vm.gclid = null;
    var queryParameters = window.location.search;
    var urlParams = new URLSearchParams(queryParameters);
    if(urlParams.has('gclid')){
      vm.gclid = urlParams.get('gclid');
    }
    this.$store.commit("togglePpcFormState", "quote");
    this.$store.dispatch("queryPPCAvailability").then(function () {
      let from = new Date(vm.disabled_from);
      from.setDate(from.getDate() + 1);
      vm.disabledDate.from = from;
      vm.disabledDate.to = new Date(vm.disabled_to);
      vm.disabled_dates.forEach(function (day) {
        vm.disabledDate.dates.push(new Date(day));
      });
      if (vm.form_complete) {
        vm.submitFormStartedEvent();
      } else {
        vm.$watch("$v.$anyDirty", function () {
          vm.submitFormStartedEvent();
        });
      }
      //vm.disabledDate.dates = vm.disabled_dates;
    });
  },
  methods: {
    submitFormStartedEvent() {
      const vm = this;
      if (!vm.formStartedSent) {
        vm.formStartedSent = true;
        vm.$gtm.trackEvent({
          event: "ppc-form-started",
          category: "lead",
          action: "form-started",
          label: vm.$store.state.user.page_url,
          noninteraction: true,
        });
      }
    },
    onHidden() {
      this.$refs.submitButton.focus();
    },
    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1000));
    },
    highlightErrors(field) {
      if (!this.has_error) {
        return false;
      }
      if (Array.isArray(this.error_keys)) {
        return this.error_keys.includes(field);
      }
      return false;
    },
    submit() {
      if (this.$v.$invalid) {
        return false;
      }
      if (!this.form_complete) {
        if (this.$store.state.user.requested_appointment_date == null) {
          this.submitAttempted = true;
        }
        // Can Trigger Event to Track Early Clicks (Because of Lack of Click State?)
        this.$v.$touch();
        return false;
      }
      const vm = this;
      this.$store
        .dispatch("submitLead", "ppc")
        .then(function () {
          if (vm.form_successful) {
            window.dataLayer?.push({ lead_email: vm.$store.state.user.email });
            vm.$gtm.trackEvent({
              event: "ppc-conversion",
              category: "lead",
              action: "success",
              label: vm.$store.state.user.page_url,
              formType: vm.$store.state.user.campaign,
              leadEmail: vm.$store.state.user.email,
              transaction_id: vm.$store.state.form_response.transactionID,
              storeID: vm.$store.state.user.ppc_store,
            });
          } else {
            vm.$gtm.trackEvent({
              event: "ppc-form-error",
              category: "lead",
              action: "validation-error",
              label: vm.$store.state.user.page_url,
            });
          }
        })
        .catch(function () {
          vm.$gtm.trackEvent({
            event: "ppc-form-error",
            category: "lead",
            action: "validation-error",
            label: vm.$store.state.user.page_url,
          });
          console.error("Lead Submission Failed");
        });
    },
    switchFormType(type) {
      const vm = this;
      vm.formType = type;
      vm.$store.commit("togglePpcFormState", type);
      if (type == "quote") {
        vm.$store.commit("setPpcCampaign", vm.quoteCampaign);
      }
      if (type == "appointment") {
        vm.$store.commit("setPpcCampaign", vm.apptCampaign);
      }
    },
    selYear(value) {
      this.$store.dispatch("loadCarMakes", value);
    },
    changedMonth(e) {
      // Setup action to query the DB and return dates
      const vm = this;
      this.$store
        .dispatch("updatePPCAvailability", { from: e })
        .then(function () {
          let from = new Date(vm.disabled_from);
          from.setDate(from.getDate() + 1);
          vm.disabledDate.from = from;
          vm.disabled_dates.forEach(function (day) {
            vm.disabledDate.dates.push(new Date(day));
          });
        });
    },
    selMake() {
      this.$store.commit("resetUserVehicleModel");
    },
    setCategory() {
      let category = 1;
      if (this.lpType == "automotive-services" || this.lpType == "index") {
        category = 1;
      }
      if (this.lpType == "residential-services") {
        category = 2;
      }
      if (this.lpType == "commercial-services") {
        category = 3;
      }
      if (this.lpType == "marine-services") {
        category = 4;
      }
      this.$store.commit("setUserServiceCategory", category);
    },
  },
};
</script>

<style>
#ppc-form {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#ppc .container {
  max-width: 100%;
}
#ppc .form-wrapper {
  padding-left: 0;
  padding-right: 0;
}
#ppc {
  min-height: 300px;
}
#ppc .form-success-ctn {
  min-height: 300px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.form-success-message {
  text-align: center;
  font-size: 22px;
  line-height: normal;
  font-weight: bold;
}
.success-message-container {
  border-radius: 15px;
  box-shadow: 2px 2px 10px #666;
}
.invalid input.form-control {
  border: solid 1px red;
}
@media (max-width: 767px) {
  #ppc .form-success-ctn {
    min-height: 300px;
  }
  #ppc {
    min-height: 300px;
  }
}
#ppc .error-message {
  color: red;
  text-align: center;
}
#ppc .form_tabs select {
  font-size: 12px;
}
#ppc .error {
  text-align: left;
  font-style: italic;
  font-weight: bold;
  font-size: 12px;
  color: red !important;
  padding: 0px;
  margin-bottom: 5px;
}
</style>
